import React from "react";
import BlockUi from '@availity/block-ui';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {Circles} from 'react-loader-spinner';
//import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import { DropDownList,MultiSelect } from '@progress/kendo-react-dropdowns';
import { Grid, GridColumn, GridToolbar } from '@progress/kendo-react-grid';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';
import { Dialog, DialogActionsBar,Window } from '@progress/kendo-react-dialogs';
// import { Window } from '@progress/kendo-react-dialogs';
import constants from "../common/restService/constant";
import GatewayGet from "../common/restService/GatewayGet";

import {process} from '@progress/kendo-data-query';
import { count } from "@progress/kendo-data-query/dist/npm/array.operators";
import '../commonStyle/tmsStyle.scss';
import $, { event } from 'jquery';  
import { Link } from "react-router-dom";
import RFQDetail from "./RFQDetail";
import * as TenderingService from './TenderingManager.service';
import CarrierSelTenderingMgr from "./CarrierSelTenderingMgr";
import InvoiceBidDetails from "../InvoiceBidDetails/InvoiceBidDetails";

// const DATA_ITEM_KEY = "TEND_TEND_SEQ_NR";
// const SELECTED_FIELD = "selected";
// const idGetter = getter(DATA_ITEM_KEY);

const dataState = {
    sort: [],
    take: 10,
    skip: 0,
  };

class TenderingManager extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reasonCode : [],
            selectedReason : {text : "Select Reason" , value : ""},
            txtcomments : "",
            multiBidArray : [],
			freightRFQArray : [],
			quotationArray : [],
            reasonDisabled : false,
            torStatus : "",
            latestTenderingNumber : -1,
            selectedState: {},
            RFQCreate: false,
            selectedQuotationData : [],
            showQuotationDetails: false,
            blocking : false,
            dataState: dataState
        }

        this.awardQuotation = this.awardQuotation.bind(this);
    }

    searchTenderingData() {
         this.setState({blocking :true});
        this.state.multiBidArray = [];
        this.state.freightRFQArray = [];
        this.state.quotationArray = [];
        this.getTenderingData();
    }

    async getFODisplayData(input){
        let props = {};
        let inputObj = {};
        let InputJSONString = "";
        props["query"] = constants.serviceRoot;
        props["headers"] = constants.serviceHeaders;
        InputJSONString = JSON.stringify(input);
        inputObj["Activity"] = "FO_DISPLAY_MB";
        inputObj["Input"] = InputJSONString;
        props.input = inputObj;
        
        const jsonResponse = await GatewayGet(props, props.input);
        if(jsonResponse != undefined && jsonResponse != null){
            if(jsonResponse["EX_HEADER"] != undefined && jsonResponse["EX_HEADER"] != null)
                this.state.torStatus = jsonResponse["EX_HEADER"]["YTOR_DOCSTATUS"];

            if(jsonResponse["EX_NOTES"] != undefined && jsonResponse["EX_NOTES"] != null){
                var notesArray = jsonResponse["EX_NOTES"];
                for(var i=0; i<notesArray.length; i++){
                    if(notesArray[i].TEXT_TYPE == "ZRSC"){
                        this.state.txtcomments = notesArray[i].TEXT;
                       
                    }
                    if(notesArray[i].TEXT_TYPE == "ZRSN"){
                        ;
                        var reasonForSelection = notesArray[i].TEXT;
                        this.state.selectedReason.text =   this.getReasonCodeText(reasonForSelection);
                       
                    }
                }
            }
        }
        // this.setState({blocking : false});
        this.enableActions( this.state.torStatus);
    }

   async getFOTenderingDisplay(input){
    //    this.setState({blocking : true});
        let props = {};
        let inputObj = {};
        let InputJSONString = "";
        props["query"] = constants.serviceRoot;
        props["headers"] = constants.serviceHeaders;
        InputJSONString = JSON.stringify(input);
        inputObj["Activity"] = "FO_TENDERING_DISPLAY";
        inputObj["Input"] = InputJSONString;
        props.input = inputObj;
        
        const jsonResponse = await GatewayGet(props, props.input);
        var responseArray = jsonResponse["DATA"];
       
			if(responseArray != undefined && responseArray != null) {
				for (var i = 0; i < responseArray.length; i++) {
					var userTimeZone = responseArray[i].USER_TIMEZONE;
					// Build Tendering Array
					if (responseArray[i].TEND_TEND_SEQ_NR != undefined && responseArray[i].TEND_TEND_SEQ_NR != null && responseArray[i].TEND_TEND_SEQ_NR != '') {
						if (parseInt(responseArray[i].TEND_TEND_SEQ_NR.trim()) > this.state.latestTenderingNumber)
							this.state.latestTenderingNumber = parseInt(responseArray[i].TEND_TEND_SEQ_NR.trim());
					}
					var tenderingObj = {};
					tenderingObj["TEND_TEND_SEQ_NR"] = "Tendering-" + responseArray[i].TEND_TEND_SEQ_NR.trim();
					tenderingObj["TEND_TEND_MANAGER"] = responseArray[i].TEND_TEND_MANAGER;
					if (responseArray[i].STEP_MAX_RESP_DUR != undefined && responseArray[i].STEP_MAX_RESP_DUR != null && responseArray[i].STEP_MAX_RESP_DUR != '') {
						var maxDurationValue = (responseArray[i].STEP_MAX_RESP_DUR / 100).toString();
						var firstPart = maxDurationValue.substr(0, maxDurationValue.length - 2);
						var lastPart = maxDurationValue.substr(maxDurationValue.length - 2, 2);
						tenderingObj["STEP_MAX_RESP_DUR"] = firstPart + ":" + lastPart;
					}
					else{
						tenderingObj["STEP_MAX_RESP_DUR"] = "";
					}

					tenderingObj["STEP_CURRCODE016"] = responseArray[i].STEP_CURRCODE016;
					tenderingObj["TEND_LIFECYCLE"] = responseArray[i].TEND_LIFECYCLE_DESC;
					if(responseArray[i].TEND_START_DATETIME_STR != undefined && responseArray[i].TEND_START_DATETIME_STR != null && responseArray[i].TEND_START_DATETIME_STR != ""){
						tenderingObj["TEND_START_DATETIME"] = responseArray[i].TEND_START_DATETIME_STR + " " + userTimeZone;
					}
					else{
						tenderingObj["TEND_START_DATETIME"] = "";
					}

					if(responseArray[i].TEND_END_DATETIME_STR != undefined && responseArray[i].TEND_END_DATETIME_STR != null && responseArray[i].TEND_END_DATETIME_STR != ""){
						tenderingObj["TEND_END_DATETIME"] = responseArray[i].TEND_END_DATETIME_STR + " " + userTimeZone;
					}
					else{
						tenderingObj["TEND_END_DATETIME"] = "";
					}

					// logic to find awarded carrier
					var isAwardedCarrier = false;
					if (responseArray[i].QUOT_ACC_RESULT == "AW") {
						isAwardedCarrier = true;
						tenderingObj["AWARDED_CARRIER"] = responseArray[i]["RFQ_TSP_SCAC"];
					}

					var isTenderingAvailable = false;
					for (var j = 0; j < this.state.multiBidArray.length; j++) {
						if (this.state.multiBidArray[j].TEND_TEND_SEQ_NR == tenderingObj["TEND_TEND_SEQ_NR"]) {
							isTenderingAvailable = true;
							if(isAwardedCarrier)
								this.state.multiBidArray[j].AWARDED_CARRIER = tenderingObj["AWARDED_CARRIER"];
						}
					}

					if (!isTenderingAvailable)
						this.state.multiBidArray.push(tenderingObj);

					// Build RFQ Array
					var rfqObj = {};
					rfqObj["TEND_TEND_SEQ_NR"] = "Tendering-" + responseArray[i].TEND_TEND_SEQ_NR.trim(); //vm.responseArray[i].TEND_TEND_SEQ_NR;
					if(responseArray[i].RFQ_REQ_NR != undefined && responseArray[i].RFQ_REQ_NR != null && responseArray[i].RFQ_REQ_NR != ""){
						responseArray[i].RFQ_REQ_NR = responseArray[i].RFQ_REQ_NR.replace(/^0+/, '');
					}
					else{
						this.state.isRFQUnavailable = true;
						responseArray[i].RFQ_REQ_NR = "Not_Created";
					}
					rfqObj["RFQ_REQ_NR"] = responseArray[i].RFQ_REQ_NR;
					rfqObj["RFQNumber"] = "RFQ "+rfqObj["RFQ_REQ_NR"];

					if (responseArray[i].RFQ_MAX_RESP_DUR != undefined && responseArray[i].RFQ_MAX_RESP_DUR != null && responseArray[i].RFQ_MAX_RESP_DUR != '') {
						var maxDurationValue = (responseArray[i].RFQ_MAX_RESP_DUR / 100).toString();
						var firstPart = maxDurationValue.substr(0, maxDurationValue.length - 2);
						var lastPart = maxDurationValue.substr(maxDurationValue.length - 2, 2);
						rfqObj["RFQ_MAX_RESP_DUR"] = firstPart + ":" + lastPart;
					}
					else{
						rfqObj["RFQ_MAX_RESP_DUR"] = "";
					}

					rfqObj["RFQ_CURRCODE016"] = responseArray[i].RFQ_CURRCODE016;
					rfqObj["RFQ_INTERNAL_ID"] = responseArray[i].RFQ_INTERNAL_ID;

					// Carrier SCAC
					rfqObj["RFQ_CARRIER_SCAC"] = responseArray[i].RFQ_CARRIER_SCAC;

					// RFQ Status
					rfqObj["RFQ_LIFECYCLE"] = responseArray[i].RFQ_LIFECYCLE_DESC;
					if(responseArray[i].RFQ_RESP_DUE_DTIME_STR != undefined && responseArray[i].RFQ_RESP_DUE_DTIME_STR != "" && responseArray[i].RFQ_RESP_DUE_DTIME_STR != "" ){
						rfqObj["RFQ_RESP_DUE_DTIME"] = responseArray[i].RFQ_RESP_DUE_DTIME_STR + " " + userTimeZone;
					}
					else{
						rfqObj["RFQ_RESP_DUE_DTIME"] = "";
					}

					if(responseArray[i].RFQ_START_DATETIME_STR != undefined && responseArray[i].RFQ_START_DATETIME_STR != "" && responseArray[i].RFQ_START_DATETIME_STR != "" ) {
						rfqObj["RFQ_START_DATETIME"] = responseArray[i].RFQ_START_DATETIME_STR + " " + userTimeZone;
					}
					else{
						rfqObj["RFQ_START_DATETIME"] = "";
					}

					if(responseArray[i].RFQ_END_DATETIME_STR != undefined && responseArray[i].RFQ_END_DATETIME_STR != "" && responseArray[i].RFQ_END_DATETIME_STR != "" ) {
						rfqObj["RFQ_END_DATETIME"] = responseArray[i].RFQ_END_DATETIME_STR + " " + userTimeZone;
					}
					else{
						rfqObj["RFQ_END_DATETIME"] = "";
					}

					var isRFQAvailable = false;
					for (var j = 0; j < this.state.freightRFQArray.length; j++) {
						if (this.state.freightRFQArray[j].TEND_TEND_SEQ_NR == rfqObj["TEND_TEND_SEQ_NR"] && this.state.freightRFQArray[j].RFQ_REQ_NR == rfqObj["RFQ_REQ_NR"])
							isRFQAvailable = true;
					}
					if (!isRFQAvailable)
						this.state.freightRFQArray.push(rfqObj);

					// Build Quotation Array
					if (responseArray[i].QUOT_RESP_SEQ_NR != undefined && responseArray[i].QUOT_RESP_SEQ_NR != null) {
						var quotationObj = {};
						quotationObj["TEND_TEND_SEQ_NR"] = "Tendering-" + responseArray[i].TEND_TEND_SEQ_NR.trim();
						quotationObj["RFQ_REQ_NR"] = responseArray[i].RFQ_REQ_NR;
						quotationObj["QUOT_PRESELECTED"] = responseArray[i].QUOT_PRESELECTED;

						// Carrier SCAC
						quotationObj["RFQ_CARRIER_SCAC"] = responseArray[i].RFQ_CARRIER_SCAC;

						quotationObj["QUOT_LIFECYCLE"] = responseArray[i].QUOT_LIFECYCLE_DESC;

						// Response Code
						quotationObj["QUOT_RESPONSE_CODE_ID"] = responseArray[i].QUOT_RESPONSE_CODE;
						quotationObj["QUOT_RESPONSE_CODE"] = responseArray[i].QUOT_RESPONSE_CODE_DESC;

						// Rejected Reason
						quotationObj["QUOT_REJ_REASON_CODE"] = responseArray[i].QUOT_REJ_REASON_CODE_DESC;

						// Rejected Reason Comments
						quotationObj["QUOT_COMMENTS"] = responseArray[i].QUOT_COMMENTS;

						// Award Status
						quotationObj["QUOT_ACC_RESULT"] = responseArray[i].QUOT_ACC_RESULT_DESC;
						quotationObj["QUOT_ACC_RESULT_CODE"] = responseArray[i].QUOT_ACC_RESULT;

						// Approval Status
						quotationObj["YTEND_RESP_STATUS"] = responseArray[i].YTEND_RESP_STATUS_DESC;
						quotationObj["YTEND_RESP_STATUS_CODE"] = responseArray[i].YTEND_RESP_STATUS;
						if(responseArray[i].QUOT_AMOUNTSUB_CHAR != undefined && responseArray[i].QUOT_AMOUNTSUB_CHAR != null && responseArray[i].QUOT_AMOUNTSUB_CHAR != ""){
							quotationObj["QUOT_AMOUNTSUB"] = responseArray[i].QUOT_AMOUNTSUB_CHAR;
						}

						else
							quotationObj["QUOT_AMOUNTSUB"] = "";

						if(responseArray[i].QUOT_SUBMIT_DATETIME_STR != undefined && responseArray[i].QUOT_SUBMIT_DATETIME_STR != null && responseArray[i].QUOT_SUBMIT_DATETIME_STR != ""){
							quotationObj["QUOT_SUBMIT_DATETIME"] = responseArray[i].QUOT_SUBMIT_DATETIME_STR + " " + userTimeZone;
						}
						else{
							quotationObj["QUOT_SUBMIT_DATETIME"] = "";
						}

						quotationObj["QUOTATION_NUMBER"] = responseArray[i].QUOT_RESP_SEQ_NR;
						quotationObj["QuotationNumber"] = "Quotation" + quotationObj["QUOTATION_NUMBER"];
						quotationObj["QUOT_STOP_DATE_FLAG"] = responseArray[i].QUOT_STOP_DATE_FLAG;

						this.state.quotationArray.push(quotationObj);
					}
				}
			}
            
    }

    getTenderingData() {
       
        var displayObj = {};
        displayObj["tor_id"] = this.props.tor_id;
        this.getFODisplayData(displayObj);
     

        var tenderingObj = {};
        tenderingObj["tor_id"] = this.props.tor_id;
        this.getFOTenderingDisplay(tenderingObj);
       
    }

    createRFQ()
    {
        this.setState({RFQCreate: true});
       
    }

    closeCreateRequestScreen() {
        this.setState({ 
            RFQCreate: false, 
            blocking: true,
        });
        this.getReasonCodeData();
        this.searchTenderingData();
    }

    async FO_Award_Quotation (input)
    {
        let props = {};
        let inputObj = {};
        let InputJSONString = "";
        props["query"] = constants.serviceRoot;
        props["headers"] = constants.serviceHeaders;
        InputJSONString = JSON.stringify(input);
        inputObj["Activity"] = "FO_AWARD_QUOTATION";
        inputObj["Input"] = InputJSONString;
        props.input = inputObj;
        const responseTotalArray = await GatewayGet(props, props.input);

       

			if(responseTotalArray != undefined && responseTotalArray != null){
				var responseArray = responseTotalArray["MESSAGE"];
				var awardQuotationStatus = responseTotalArray["STATUS"];

				if(awardQuotationStatus != undefined && awardQuotationStatus != null && awardQuotationStatus != ""){
					if(awardQuotationStatus == "SUCCESS"){
						toast.success("Quotation awarded successfully , please check for approval flow if it is relevant for approval.");
                        this.setState({blocking : false});

						// Updating Reason
						this.updateReason();
						// Updating Comments
						this.updateComments();
					}
					else{
						toast.error(responseTotalArray +"Award Quotation Failed");
                        this.setState({blocking : false});
					}
				}
				else{
					toast.error(responseTotalArray+"Award Quotation Failed");
                    this.setState({blocking : false});
				}
			}
			else{
				toast.error("Invalid Response when trying to Award Quotation");
                this.setState({blocking : false});
			}
			// Refresh grid
			this.searchTenderingData();
    }

    async ReasonUpdate(input)
    {
        let props = {};
        let inputObj = {};
        let InputJSONString = "";
        props["query"] = constants.serviceRoot;
        props["headers"] = constants.serviceHeaders;
        InputJSONString = JSON.stringify(input);
        inputObj["Activity"] = "FO_UPDATE_TEXT";
        inputObj["Input"] = InputJSONString;
        props.input = inputObj;
        const updateReasonResp = await GatewayGet(props, props.input);

        if(updateReasonResp.STATUS === "SUCCESS")
        {
            toast.success("Updating Reasons Success");
        }
        else{

            toast.error("Updating Reasons Failed");
        }
    }

    updateReason (){
        var updateReasonObj = {};
        updateReasonObj["tor_id"] = this.props.tor_id;
        updateReasonObj["im_texttype"] = "ZRSN";
        updateReasonObj["im_textcontent"] = this.state.selectedReason.value;

       this.ReasonUpdate(updateReasonObj);
    }

    async CommentsUpdate(input) {
        let props = {};
        let inputObj = {};
        let InputJSONString = "";
        props["query"] = constants.serviceRoot;
        props["headers"] = constants.serviceHeaders;
        InputJSONString = JSON.stringify(input);
        inputObj["Activity"] = "FO_UPDATE_TEXT";
        inputObj["Input"] = InputJSONString;
        props.input = inputObj;
        const updateReasonResp = await GatewayGet(props, props.input);

        if(updateReasonResp.STATUS === "SUCCESS")
        {
            toast.success("Updating Comments Success");
        }
        else{

            toast.error("Updating Comments Failed");
        }
    }

    updateComments ()
    {
        var updateCommentsObj = {};
			updateCommentsObj["tor_id"] = this.props.tor_id;
			updateCommentsObj["im_texttype"] = "ZRSC";
			updateCommentsObj["im_textcontent"] = this.state.txtcomments;

			this.CommentsUpdate(updateCommentsObj);
    }

    viewQuotation()
    {
        
    }

    awardQuote ()
    {
        this.setState({blocking : true});
        var awardObj = {};
			awardObj["foNum"] = this.props.tor_id;
			awardObj["rfqNum"] = this.state.selectedQuotationData.RFQ_REQ_NR;
			awardObj["respSeqNum"] = this.state.selectedQuotationData.QUOTATION_NUMBER;
            this.state.latestQuotationNumber = "";
        if(this.state.selectedQuotationData.YTEND_RESP_STATUS_CODE == "03" || this.state.selectedQuotationData.QUOT_RESPONSE_CODE_ID == "RE" || this.state.selectedQuotationData.QUOT_ACC_RESULT_CODE == "RE" || this.state.selectedQuotationData.QUOT_ACC_RESULT_CODE == "AW"){
            toast.error("Cannot Award Rejected Quotation - Please Select a valid quotation to Award")
            this.setState({blocking : false});
        }

        if(this.state.selectedQuotationData.TEND_TEND_SEQ_NR == "Tendering-" + this.state.latestTenderingNumber){
            for(var i=0; i<this.state.quotationArray.length; i++){
                if(this.state.selectedQuotationData.RFQ_REQ_NR == this.state.quotationArray[i].RFQ_REQ_NR){
                    if(parseInt(this.state.quotationArray[i].QUOTATION_NUMBER.trim()) > this.state.latestQuotationNumber)
                        this.state.latestQuotationNumber = this.state.quotationArray[i].QUOTATION_NUMBER;
                }
            }

            if(this.state.selectedQuotationData.QUOTATION_NUMBER == this.state.latestQuotationNumber) {
                // vm.selectedReason = angular.element("#reasonForSelectionDD").val();
                // vm.selectedReasonText = angular.element("#reasonForSelectionDD").data("kendoDropDownList").text();

                if(this.state.selectedReason != undefined && this.state.selectedReason != null && this.state.selectedReason.text != "" && this.state.selectedReason.text != "Select Reason"){
                   
                    if(this.state.selectedReason.value == "05"){
                        var comments = this.state.txtcomments;

                        if(comments != undefined || comments == null || comments == ""){
                            toast.error("Comments is mandatory for Reason:" + this.state.selectedReason.text);
                            this.setState({blocking : false});
                            
                            return;
                        }
                        else{
                            
                        }
                    }
                    // blockUI.start("Loading please wait...");
                    // getTMData.callGatewayService("FO_AWARD_QUOTATION", awardObj).then(onAwardQuotationSuccess, onAwardQuotationFailure);
                    this.FO_Award_Quotation(awardObj);
                }
                else{
                   

                    toast.error("Reason for Selection is mandatory")
                    this.setState({blocking : false});
                }
            }
            else {
                toast.error("Select a Valid Quotation to Award")
                this.setState({blocking : false});
                
            }
        }
        else{
            toast.error("Select a Valid Quotation to Award")
            this.setState({blocking : false});
            
        }
    }

    viewQuotation() {
        if (this.state.selectedQuotationData.length === 0) {
          toast.error('Please select a Quotation');
          return;
        }
        this.setState({ showQuotationDetails: true });
      }

      hideQuotation() {
        this.setState({ showQuotationDetails: false });
      }

    awardQuotation(data) 
    {
        ;
console.log(data);
this.getSelectedQuotationData(data);
//  this.state.selectedQuotationData = data;
// this.setState({selectedQuotationData : data})

    }

    getSelectedQuotationData(data)
    {
        this.setState({selectedQuotationData : data});
    }

    stopTendering() {
 this.setState({dialogvisible : true,
    stopTendMessage : "Tendering-" + this.state.latestTenderingNumber + " will be stopped. Click Confirm to Proceed."})

    }

    async tenderingStop(stopObj)
    {
        let props = {};
        let inputObj = {};
        let InputJSONString = "";
        props["query"] = constants.serviceRoot;
        props["headers"] = constants.serviceHeaders;
        InputJSONString = JSON.stringify(stopObj);
        inputObj["Activity"] = "FO_STOP_TENDERING";
        inputObj["Input"] = InputJSONString;
        props.input = inputObj;
        const jsonResponse = await GatewayGet(props, props.input);
        if(jsonResponse.STATUS == "SUCCESS")
        {
        toast.success("Stop Tendering process:" + jsonResponse.STATUS);
        this.searchTenderingData();
        }

        if(jsonResponse.STATUS == "FAILURE")
        {
            toast.error("Stop Tendering process: Failed");
        }
    }

    stopTendConfirmed(){
        this.setState({dialogvisible : false});
        var stopObj = {};
        stopObj["tor_id"] = this.props.tor_id;
        this.tenderingStop(stopObj);

       
    }

    cancelDialog(){
        this.setState({dialogvisible : false});
    }

    refresh()
    {
        this.searchTenderingData();
    }

    getReasonCodeText(value) {
        for (var i = 0; i < this.state.reasonCode.length; i++) {
          if (this.state.reasonCode[i].value == value) {
            return this.state.reasonCode[i].text;
          }
        }
    
        
      }

   async  getReasonCodeData ()
    {
       const reasonCodeResponse = await TenderingService.getReasonCode();
       this.setState({reasonCode : reasonCodeResponse});
      
    }
    
    handleReasonChange = (e) => {

        this.setState({selectedReason : e.target.value});
    }

    componentDidMount(){
        //  this.setState({blocking :true});
        this.getReasonCodeData();
        this.searchTenderingData();
    }

    enableActions = function(torStatus){
        // vm.showReason = false;
      
        this.setState({showReason : false});

        if(torStatus != undefined && torStatus != null && torStatus != '') {
            // Disable Reason initially
           this.setState({reasonDisabled : true});
            // Show/ Hide Reason Dropdown
            if(torStatus == "35" || torStatus == "45" || torStatus == "60" || torStatus == "70" || torStatus == "80" || torStatus == "90" ){
                this.setState({showReason : true});
                this.setState({blocking : false});
            }
            // Enable/ Disable buttons
            if (torStatus == "10" || torStatus == "55" || torStatus == "60" || torStatus == "70" || torStatus == "90" || torStatus == "73" || torStatus == "77") {
                this.setState({disableCreateQuotation : true,disableStopQuotation : true,disableAwardQuotation : true})
                this.setState({blocking : false});
               
            }
            else if (torStatus == "20") {
                this.setState({disableCreateQuotation : false,disableStopQuotation : true,disableAwardQuotation : true})
                this.setState({blocking : false});
               
            }
            else if (torStatus == "35" || torStatus == "45" || torStatus == "80") {
                this.setState({disableCreateQuotation : true,disableStopQuotation : false,disableAwardQuotation : false,reasonDisabled : false})
                this.setState({blocking : false});
               
                
                
            }
        }
        // this.setState({blocking:false});
    }
    expandChange = (event) => {
debugger;
        const isExpanded =
            event.dataItem.expanded === undefined ?
                event.dataItem.aggregates : event.dataItem.expanded;
        event.dataItem.expanded = !isExpanded;
        event.dataItem.rfqData = this.state.freightRFQArray;
        event.dataItem.quoteData = this.state.quotationArray;
        event.dataItem.awardQuotation =  this.awardQuotation;
        this.setState({ ...this.state });
    }



    handleRowClick = (event) => {
;
        console.log(event);
    }
   

    render()
    {

        const grid = (

            <Grid
                ScrollMode="scrollable"
                style={{ height: "600px", width: 'auto'}}
                pageable = {true}
                sortable             
               // data = {jsonData}   
                data={process(this.state.multiBidArray, this.state.dataState)}
                {...this.state.dataState}
                 onDataStateChange={(e) => {
                this.setState({ dataState: e.dataState });
                }}       
                ref={(grid) => { this._grid = grid; }}
                detail= {RFQDetail}
                expandField="expanded"
                onExpandChange={this.expandChange}
                selectedField="selected"
                onRowClick={this.handleRowClick}
            
    
            >
                

                <GridColumn field="TEND_TEND_SEQ_NR" title="MultiBid/ Freight RFQ/ Quote"  width="200px" />    
                <GridColumn field="TEND_TEND_MANAGER" title="Tendering Manager"    width="150px"   /> 
                    
                <GridColumn field="STEP_MAX_RESP_DUR" title="Max Response Duration"   width = "100px" />
                <GridColumn field="STEP_CURRCODE016" title="Currency Code"   width="100px"  />             
                 
                 <GridColumn field="AWARDED_CARRIER" title="Awarded Carrier"  width="100px"></GridColumn>
                 <GridColumn field="RFQ_CARRIER_SCAC" title="Carrier SCAC"  width = "100px"></GridColumn>
                 <GridColumn field="proposedCarrier" title="Proposed Carrier"  width="120px"></GridColumn>
                 <GridColumn field="TEND_LIFECYCLE" title="Status"  width="120px"></GridColumn>
                 <GridColumn field="response" title="Response"  width = "120px"></GridColumn>  
                 <GridColumn field="submittedPrice" title="Submitted Price"  width = "100px"></GridColumn> 
                 <GridColumn field="rejectionReason" title="Rejection Reason"  width = "100px"></GridColumn> 
                 <GridColumn field="quotationComments" title="RFQ Rejection Comments"  width = "100px"></GridColumn> 
                 <GridColumn field="QUOT_ACC_RESULT" title="Award Status"  width = "100px"></GridColumn> 
                 <GridColumn field="YTEND_RESP_STATUS" title="Approval Status"  width = "100px"></GridColumn> 
                 <GridColumn field="differentStopDatesProposed" title="Different Stop Dates Proposed"  width = "100px"></GridColumn> 
                 <GridColumn field="latestFQDueDateTime" title="Latest FQ Due Date Time"  width = "100px"></GridColumn> 
                 <GridColumn field="TEND_START_DATETIME" title="RFQ Start Date Time"  width = "100px"></GridColumn> 
                 <GridColumn field="TEND_END_DATETIME" title="RFQ End Date Time"  width = "100px"></GridColumn> 
                 <GridColumn field="submissionDateTime" title="Submission Date Time" width = "200px" ></GridColumn>

                 
               
            </Grid>
        );
        if (!this.state.RFQCreate && !this.state.showQuotationDetails) {
        return(
            
            <div className="RFQ">
                   {this.state.dialogvisible && <Dialog title={"Confirmation"} onClose={this.cancelDialog}>
                    <p style={{ margin: "25px", textAlign: "center", color: "#004A86" }}>{this.state.stopTendMessage}</p>
                    <DialogActionsBar>
                    <button className="btn k-button" onClick={this.cancelDialog}>Cancel</button>
                        <button className="btn k-button" onClick={this.stopTendConfirmed.bind(this)}>Confirm</button>
                    </DialogActionsBar>
                </Dialog>}
            <BlockUi tag="div" blocking={this.state.blocking}
    
    loader={ <Circles
        color="#00BFFF"
        height="100"
        width="100"
        timeout="6000" //3 secs
      />}>
             <div>
             {/* <ToastContainer
position="top-right"
autoClose={5000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
/> */}
{/* Same as */}
{/* <ToastContainer /> */}

        </div>
        {/* <MDBContainer fluid >
            <MDBRow>
                <MDBCol sm="12" className="titleBox" ><label style={{ textAlign: "center" }}></label></MDBCol>
            </MDBRow>
            </MDBContainer>  */}
            <MDBContainer fluid className="tender-top"> 
             <MDBRow>
                 <MDBCol>
                     <button className="btn k-button k-button-icontext" onClick = {this.createRFQ.bind(this)} disabled = {this.state.disableCreateQuotation}>Create Request For Quotation</button> &nbsp;&nbsp;&nbsp;&nbsp;
                     <button className="btn k-button k-button-icontext" disabled = {this.state.disableStopQuotation} onClick = {this.stopTendering.bind(this)}>Stop</button> &nbsp;&nbsp;&nbsp;&nbsp;
                     <button className="btn k-button k-button-icontext" disabled = {this.state.disableAwardQuotation} onClick = {this.awardQuote.bind(this)} >Award Quotation </button> &nbsp;&nbsp;&nbsp;&nbsp;
                     <button className="btn k-button k-button-icontext" onClick = {this.viewQuotation.bind(this)}>Quotation Details</button> &nbsp;&nbsp;&nbsp;&nbsp;
                     <button className="btn k-button k-button-icontext" onClick = {this.refresh.bind(this)}>Refresh</button>
                 </MDBCol>
             </MDBRow>
             <br></br>
                         
             <MDBContainer fluid>
                 <MDBRow>
                     {grid}
                 </MDBRow>
                 <br></br>
                 <br></br>
                 <MDBRow>
                     <MDBCol><label>Reasons For Selection<em>*</em></label></MDBCol>
                     <MDBCol md = "2"><DropDownList data = {this.state.reasonCode} disabled = {this.state.reasonDisabled} dataItemKey = {"value"} textField ={"text"} value = {this.state.selectedReason} onChange = {this.handleReasonChange.bind(this)}></DropDownList></MDBCol>
                     <MDBCol md="1">Comments</MDBCol>
                     <MDBCol md = "2"><input type = "text" className="form-control"  value = {this.state.txtcomments} 
                     onChange={(event) =>
                        this.setState({ txtcomments: event.target.value })}
                     ></input></MDBCol>
                 </MDBRow>
             </MDBContainer>
            </MDBContainer>

         
            
            </BlockUi>   

            </div>
        );
    }
    else if (this.state.RFQCreate) {
        return (
          <CarrierSelTenderingMgr
            serviceType={this.props.serviceType}
            shipFrom={this.props.shipFrom}
            shipTo={this.props.shipTo}
            transportationValue={this.props.TransportationValue}
            tor_id={this.props.tor_id}
            closeCreateRequestScreen={this.closeCreateRequestScreen.bind(this)}
          />
        );
        
      } else if (this.state.showQuotationDetails) {
        return (
          <InvoiceBidDetails
            props={{
              currentComponent: "bid",
              ParentScacCode: null,
              tor_id: this.props.tor_id,
              ReqPickupDate: this.props.ReqPickupDate,
              ReqDeliveryDate: this.props.ReqDeliveryDate,
              docStatus:this.props.docStatus,
              vendor_id: this.props.vendor_id,
              TransportationValue: this.props.TransportationValue,
              tor_Type: 'ZMSB',
              onBidSaved: () => {},
              invoiceInputs: {
                childSCAC: null,
                hawbNumber: null,
                proNumber: null,
              },
              isEditClicked: false,
              isCreaedUserDifferentFromLoggedInUserAtStatus10: false,
              onEditingFinished: () => {},
              isNewRequest: false,
              invoiceDetailInputsOnSubmit: null,
              saveInvoiceDetailInputsOnSubmit: () => {},
              rfq_no: this.state.selectedQuotationData?.RFQ_REQ_NR,
              hideQuotation: this.hideQuotation.bind(this),
              quotationNum: this.state.selectedQuotationData?.QUOTATION_NUMBER,
              timeFromZone: this.props.timeFromZone,
              timeToZone: this.props.timeToZone
            }}
          />
        );
      }
  
}
}

export default TenderingManager;